/* Generated by scripts/build-bundles.js from 12 files - do not edit. */
/* product-gallery-fixed.js */
// Product Gallery Fixed JavaScript with Video Support
class ProductGallery {
  constructor() {
    this.gallery = document.querySelector('[data-product-gallery]');
    if (!this.gallery) return;
    
    // Elements
    this.slides = this.gallery.querySelectorAll('.gallery__slide');
    this.thumbs = this.gallery.querySelectorAll('.gallery__thumb');
    this.dots = this.gallery.querySelectorAll('.gallery__dot');
    this.prevButton = this.gallery.querySelector('[data-gallery-prev]');
    this.nextButton = this.gallery.querySelector('[data-gallery-next]');
    this.expandButton = this.gallery.querySelector('[data-gallery-expand]');
    
    // Lightbox elements
    this.lightbox = document.querySelector('[data-lightbox]');
    this.lightboxSlides = this.lightbox?.querySelectorAll('.lightbox__slide');
    this.lightboxClose = this.lightbox?.querySelectorAll('[data-lightbox-close]');
    this.lightboxPrev = this.lightbox?.querySelector('[data-lightbox-prev]');
    this.lightboxNext = this.lightbox?.querySelector('[data-lightbox-next]');
    this.lightboxCounter = this.lightbox?.querySelector('[data-current-index]');
    
    // Video elements
    this.videos = this.gallery.querySelectorAll('video');
    this.lightboxVideos = this.lightbox?.querySelectorAll('video');
    
    // State
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    
    // Initialize
    this.init();
  }
  
  init() {
    // Bind navigation
    this.prevButton?.addEventListener('click', () => this.navigate('prev'));
    this.nextButton?.addEventListener('click', () => this.navigate('next'));
    
    // Bind thumbnails
    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Bind dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Bind expand/lightbox
    this.expandButton?.addEventListener('click', () => this.openLightbox());
    
    // Bind lightbox controls
    this.lightboxClose?.forEach(btn => {
      btn.addEventListener('click', () => this.closeLightbox());
    });
    
    this.lightboxPrev?.addEventListener('click', () => this.navigateLightbox('prev'));
    this.lightboxNext?.addEventListener('click', () => this.navigateLightbox('next'));
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (this.lightbox?.classList.contains('is-open')) {
        if (e.key === 'Escape') this.closeLightbox();
        if (e.key === 'ArrowLeft') this.navigateLightbox('prev');
        if (e.key === 'ArrowRight') this.navigateLightbox('next');
      } else if (this.gallery.contains(document.activeElement)) {
        if (e.key === 'ArrowLeft') this.navigate('prev');
        if (e.key === 'ArrowRight') this.navigate('next');
      }
    });
    
    // Touch/swipe support
    this.addSwipeSupport();
    
    // Initial setup
    this.checkThumbsScroll();
    
    // Check on window resize
    window.addEventListener('resize', () => {
      this.checkThumbsScroll();
    });
  }
  
  navigate(direction) {
    if (direction === 'prev') {
      this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.totalSlides - 1;
    } else {
      this.currentIndex = this.currentIndex < this.totalSlides - 1 ? this.currentIndex + 1 : 0;
    }
    
    this.goToSlide(this.currentIndex);
  }
  
  goToSlide(index) {
    // Update current index
    this.currentIndex = index;
    
    // Pause all videos
    this.videos.forEach(video => {
      video.pause();
    });
    
    // Update slides
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    
    // Update thumbnails
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
    });
    
    // Update dots
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
    
    // Scroll active thumbnail into view
    const activeThumb = this.thumbs[index];
    if (activeThumb) {
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
    
    // Check if thumbnails are scrollable
    this.checkThumbsScroll();
  }
  
  checkThumbsScroll() {
    const thumbsContainer = this.gallery.querySelector('.gallery__thumbs-container');
    const thumbsWrapper = this.gallery.querySelector('.gallery__thumbs');
    
    if (thumbsContainer && thumbsWrapper) {
      const hasScroll = thumbsWrapper.scrollWidth > thumbsWrapper.clientWidth;
      thumbsContainer.classList.toggle('has-scroll', hasScroll);
    }
  }
  
  openLightbox() {
    if (!this.lightbox) return;
    
    this.lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    // Sync lightbox with current gallery image
    this.updateLightbox(this.currentIndex);
  }
  
  closeLightbox() {
    if (!this.lightbox) return;
    
    // Pause any playing videos
    this.lightboxVideos?.forEach(video => {
      video.pause();
    });
    
    this.lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  
  navigateLightbox(direction) {
    let newIndex = this.currentIndex;
    
    if (direction === 'prev') {
      newIndex = newIndex > 0 ? newIndex - 1 : this.totalSlides - 1;
    } else {
      newIndex = newIndex < this.totalSlides - 1 ? newIndex + 1 : 0;
    }
    
    this.updateLightbox(newIndex);
    this.goToSlide(newIndex); // Sync with main gallery
  }
  
  updateLightbox(index) {
    // Update lightbox slides
    this.lightboxSlides?.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    
    // Update counter
    if (this.lightboxCounter) {
      this.lightboxCounter.textContent = index + 1;
    }
  }
  
  addSwipeSupport() {
    let touchStartX = 0;
    let touchEndX = 0;
    
    const handleSwipe = () => {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          this.navigate('next');
        } else {
          this.navigate('prev');
        }
      }
    };
    
    // Main gallery swipe
    this.gallery.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    this.gallery.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
    
    // Lightbox swipe
    if (this.lightbox) {
      this.lightbox.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      this.lightbox.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        if (this.lightbox.classList.contains('is-open')) {
          const diff = touchStartX - touchEndX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              this.navigateLightbox('next');
            } else {
              this.navigateLightbox('prev');
            }
          }
        }
      }, { passive: true });
    }
  }
}

// Sticky gallery offsets (desktop). The gallery column is often taller than
// a laptop viewport, so pinning it at the top would hide its lower part.
// When it does not fit, the sticky top goes negative so the column scrolls
// until its bottom edge is in view and pins there. Read by product-gallery.css.
function initStickyGallery() {
  const gallery = document.querySelector('.product-hero-grid > .product-hero-gallery');
  if (!gallery) return;

  const TOP = 24;
  const TOP_WITH_HEADER = 135;
  const BOTTOM = 24;

  const update = () => {
    const fitTop = window.innerHeight - gallery.offsetHeight - BOTTOM;
    gallery.style.setProperty('--gallery-sticky-top', `${Math.min(TOP, fitTop)}px`);
    gallery.style.setProperty('--gallery-sticky-top-header', `${Math.min(TOP_WITH_HEADER, fitTop)}px`);
  };

  update();
  window.addEventListener('resize', update, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(gallery);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductGallery();
    initStickyGallery();
    initShippingCalculator();
  });
} else {
  new ProductGallery();
  initStickyGallery();
  initShippingCalculator();
}

// Shipping calculator functionality
function initShippingCalculator() {
  // Use event delegation for calculate button
  document.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('calculate-btn')) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Calculate button clicked!');
      
      const form = e.target.closest('form[data-shipping-calculator]');
      if (!form) {
        console.error('Could not find shipping calculator form');
        return;
      }
      
      const zipInput = form.querySelector('input[data-shipping-zip]');
      const resultsDiv = document.querySelector('[data-shipping-results]');
      
      if (!zipInput || !resultsDiv) {
        console.error('Could not find required elements', { zipInput, resultsDiv });
        return;
      }
      
      const zip = zipInput.value.trim();
      console.log('ZIP code entered:', zip);
      
      // Validate ZIP
      if (!zip || !/^\d{5}$/.test(zip)) {
        resultsDiv.innerHTML = '<p style="color: red; padding: 10px; background: #ffe6e6; border-radius: 4px;">Please enter a valid 5-digit ZIP code</p>';
        resultsDiv.style.display = 'block';
        return;
      }
      
      // Show loading with premium styling
      resultsDiv.innerHTML = `
        <div style="text-align: center; padding: 40px 20px;">
          <div style="display: inline-flex; align-items: center; justify-content: center; width: 60px; height: 60px; background: #f0f2f5; border-radius: 50%; margin-bottom: 16px;">
            <i class="fas fa-spinner fa-spin" style="font-size: 24px; color: #03045e;"></i>
          </div>
          <p style="color: #666; font-size: 14px; margin: 0;">Calculating best shipping options for ${zip}...</p>
        </div>
      `;
      resultsDiv.style.display = 'block';
      
      // Simulate calculation and show results
      setTimeout(() => {
        // Calculate delivery dates
        const today = new Date();
        const formatDate = (daysToAdd) => {
          const date = new Date(today);
          date.setDate(date.getDate() + daysToAdd);
          return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        };
        
        resultsDiv.innerHTML = `
          <style>
            .shipping-results-header {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-bottom: 20px;
              padding-bottom: 16px;
              border-bottom: 1px solid #e5e5e5;
            }
            
            .shipping-results-header i {
              color: #03045e;
              font-size: 20px;
            }
            
            .shipping-results-header h4 {
              font-size: 16px;
              font-weight: 600;
              color: #333;
              margin: 0;
            }
            
            .delivery-options {
              display: flex;
              flex-direction: column;
              gap: 12px;
            }
            
            .shipping-option {
              background: #f8f9fa;
              border: 2px solid #e5e5e5;
              border-radius: 12px;
              padding: 16px;
              position: relative;
              transition: all 0.2s ease;
              cursor: pointer;
            }
            
            .shipping-option:hover {
              border-color: #03045e;
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(3, 4, 94, 0.1);
            }
            
            .shipping-option--free {
              background: linear-gradient(135deg, #f0f9ff 0%, #e6f4f1 100%);
              border-color: #00c66b;
            }
            
            .shipping-option--free .option-header h4 {
              color: #00875a;
            }
            
            .option-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 8px;
            }
            
            .option-header h4 {
              font-size: 15px;
              font-weight: 600;
              color: #333;
              margin: 0;
            }
            
            .option-header .price {
              font-size: 16px;
              font-weight: 700;
              color: #03045e;
            }
            
            .shipping-option--free .price {
              color: #00c66b;
              font-size: 14px;
              background: rgba(0, 198, 107, 0.1);
              padding: 4px 12px;
              border-radius: 20px;
            }
            
            .delivery-date {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 13px;
              color: #666;
              margin: 0;
            }
            
            .delivery-date i {
              color: #999;
              font-size: 14px;
            }
            
            .delivery-date strong {
              color: #333;
            }
            
            .fastest-badge {
              position: absolute;
              top: 12px;
              right: 12px;
              background: #ff6b35;
              color: white;
              font-size: 11px;
              font-weight: 600;
              padding: 4px 10px;
              border-radius: 12px;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
            
            .shipping-option--recommended {
              background: linear-gradient(135deg, #f5f3ff 0%, #ede9ff 100%);
              border-color: #6b46c1;
            }
            
            .recommended-badge {
              position: absolute;
              top: -10px;
              left: 50%;
              transform: translateX(-50%);
              background: #6b46c1;
              color: white;
              font-size: 11px;
              font-weight: 600;
              padding: 4px 16px;
              border-radius: 12px;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            }
            
            .shipping-note {
              margin-top: 20px;
              padding: 12px;
              background: #f8f9fa;
              border-radius: 8px;
              text-align: center;
              color: #666;
              font-size: 12px;
              border: 1px solid #e5e5e5;
            }
            
            .shipping-note i {
              color: #03045e;
              margin-right: 6px;
            }
          </style>
          
          <div class="shipping-results-header">
            <i class="fas fa-truck"></i>
            <h4>Shipping to ${zip}</h4>
          </div>
          
          <div class="delivery-options">
            <div class="shipping-option shipping-option--free">
              <div class="option-header">
                <h4>Standard Shipping</h4>
                <span class="price">FREE</span>
              </div>
              <p class="delivery-date">
                <i class="fas fa-box"></i>
                Arrives by <strong>${formatDate(5)} - ${formatDate(7)}</strong>
              </p>
            </div>
            
            <div class="shipping-option shipping-option--recommended">
              <span class="recommended-badge">Recommended</span>
              <div class="option-header">
                <h4>Express Shipping</h4>
                <span class="price">$12.99</span>
              </div>
              <p class="delivery-date">
                <i class="fas fa-shipping-fast"></i>
                Arrives by <strong>${formatDate(2)} - ${formatDate(3)}</strong>
              </p>
            </div>
            
            <div class="shipping-option">
              <span class="fastest-badge">Fastest</span>
              <div class="option-header">
                <h4>Overnight Shipping</h4>
                <span class="price">$29.99</span>
              </div>
              <p class="delivery-date">
                <i class="fas fa-bolt"></i>
                Arrives by <strong>${formatDate(1)}</strong>
              </p>
            </div>
          </div>
          
          <div class="shipping-note">
            <i class="fas fa-info-circle"></i>
            <small>Final shipping cost will be calculated at checkout based on your complete address</small>
          </div>
        `;
        resultsDiv.style.display = 'block';
      }, 800);
    }
  });
}
;
/* product-sticky-header.js */
// Format a price in cents using the shopper's active currency
// (window.formatMoney comes from money-format.js)
function money(cents) {
  return window.formatMoney ? window.formatMoney(cents) : '$' + (Number(cents) / 100).toFixed(2);
}

class ProductStickyHeader {
  // Desktop reveals the bar at this fraction of total scroll depth, and only hides
  // again below HIDE. The gap is deliberate hysteresis: with a single threshold the
  // bar flaps on/off, because the trigger is a fraction of a page height that keeps
  // changing (lazy video/map/images add ~330px after load, the cart drawer locks the
  // body) and a 1px scroll at the boundary is enough to flip it.
  static DESKTOP_SHOW = 0.25;
  static DESKTOP_HIDE = 0.20;

  constructor() {
    this.header = document.querySelector('[data-sticky-header]');
    if (!this.header) return;
    
    this.triggerPoint = 300;
    this.isVisible = false;
    this.mainProductInfo = document.querySelector('.product-info');
    this.mainAddToCart = document.querySelector('.product-form .add-to-cart');
    
    this.init();
  }
  
  resetButtonState(button) {
    if (!button) return;
    
    // Remove all state classes
    button.classList.remove('button--loading', 'is-success', 'is-error');
    button.disabled = false;
    
    // Ensure proper display of elements
    const buttonLoading = button.querySelector('.button__loading');
    const buttonText = button.querySelector('.button__text');
    
    if (buttonLoading) {
      buttonLoading.style.display = 'none';
    }
    
    if (buttonText) {
      buttonText.style.display = 'inline-flex';
    }
  }
  
  init() {
    // Debounced scroll handler
    let scrollTimer;
    let ticking = false;
    
    const requestTick = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(requestTick, 10);
    });
    
    // Crossing the 768px breakpoint swaps which trigger applies, and a resize also
    // changes total scroll height - re-evaluate so the bar cannot get stuck.
    window.addEventListener('resize', () => this.handleScroll());

    // Initial check
    this.handleScroll();
    
    // Form submission
    const form = this.header.querySelector('[data-sticky-form]');
    if (form) {
      form.addEventListener('submit', this.handleAddToCart.bind(this));
      
      // Ensure button states are correct when it receives focus
      const addToCartBtn = form.querySelector('[data-add-to-cart]');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('focus', () => {
          // Reset button to normal state when it receives focus
          this.resetButtonState(addToCartBtn);
        });
        
        // Also handle blur to ensure clean state
        addToCartBtn.addEventListener('blur', () => {
          // Reset button to normal state when it loses focus
          this.resetButtonState(addToCartBtn);
        });
      }
    }
    
    // Cart button. The header binds its own toggle scoped to the header element, so
    // this one needs wiring; same open path it uses.
    const cartBtn = this.header.querySelector('[data-cart-drawer-toggle]');
    if (cartBtn) {
      cartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:open'));

        if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
          window.cartDrawer.open();
          window.cartDrawer.refreshCart();
        } else if (window.openCartDrawer) {
          window.openCartDrawer();
        } else {
          window.location.href = '/cart';
        }
      });
    }

    // Keep the badge accurate for adds made elsewhere on the page.
    document.addEventListener('cart:updated', () => this.refreshCartCount());
    this.refreshCartCount();

    // Wishlist toggle
    const wishlistBtn = this.header.querySelector('[data-wishlist-toggle]');
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', this.toggleWishlist.bind(this));
    }
    
    // Variant selector
    const variantSelect = this.header.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
    }
    
    // Listen for variant changes from main product form
    document.addEventListener('variant:change', this.syncVariant.bind(this));
  }
  
  isDesktop() {
    return window.matchMedia('(min-width: 769px)').matches;
  }

  // Reads the real cart and syncs every [data-cart-count] badge, matching the
  // header's convention of hiding the badge at zero.
  async refreshCartCount() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('cart-count--empty', cart.item_count === 0);
      });
    } catch (err) {
      /* badge is cosmetic - a failed refresh must not break the add itself */
    }
  }

  // How far down the page we are, 0-1.
  scrollProgress() {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    return max > 0 ? window.scrollY / max : 0;
  }

  handleScroll() {
    const scrollY = window.scrollY;
    let shouldShow = false;

    if (this.isDesktop()) {
      // Desktop needs its own trigger: .product-info is position:sticky here, so its
      // bounding box stays pinned near the top and rect.bottom < 0 is never true -
      // the element test below silently never fires, which is why the bar was absent
      // on desktop. Reveal at 25% scroll depth instead, and once shown keep it until
      // the reader scrolls well back up.
      const progress = this.scrollProgress();
      shouldShow = this.isVisible
        ? progress >= ProductStickyHeader.DESKTOP_HIDE
        : progress >= ProductStickyHeader.DESKTOP_SHOW;
    } else if (this.mainProductInfo) {
      // Check if main product info or add to cart is out of view
      const rect = this.mainProductInfo.getBoundingClientRect();
      shouldShow = rect.bottom < 0;
    } else if (this.mainAddToCart) {
      const rect = this.mainAddToCart.getBoundingClientRect();
      shouldShow = rect.bottom < 0;
    } else {
      // Fallback to scroll distance
      shouldShow = scrollY > this.triggerPoint;
    }

    if (shouldShow && !this.isVisible) {
      this.show();
    } else if (!shouldShow && this.isVisible) {
      this.hide();
    }
  }
  
  show() {
    this.isVisible = true;
    this.header.style.transform = 'translateY(0)';
    this.header.classList.add('is-visible');
    
    // Add class to body for spacing adjustments
    document.body.classList.add('sticky-header-visible');
    
    // Track event
    if (typeof gtag !== 'undefined') {
      gtag('event', 'view_sticky_header', {
        item_id: this.header.dataset.productId,
        scroll_depth: window.scrollY
      });
    }
  }
  
  hide() {
    this.isVisible = false;
    this.header.style.transform = 'translateY(-100%)';
    this.header.classList.remove('is-visible');
    document.body.classList.remove('sticky-header-visible');
  }
  
  async handleAddToCart(e) {
    e.preventDefault();
    
    const form = e.target;
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = button.querySelector('.button__text');
    const buttonLoading = button.querySelector('.button__loading');
    
    // Loading state
    button.disabled = true;
    buttonText.style.display = 'none';
    buttonLoading.style.display = 'inline-flex';
    
    try {
      const formData = new FormData(form);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        const item = await response.json();
        
        // Success animation
        buttonLoading.style.display = 'none';
        buttonText.style.display = 'inline-flex';
        buttonText.innerHTML = `
          <svg class="icon icon--check" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Added!
        `;
        button.classList.add('is-success');

        // Keep every cart badge on the page in step, including this bar's own.
        this.refreshCartCount();

        // Update cart drawer if it exists
        if (window.cartDrawer) {
          window.cartDrawer.refreshCart();
          setTimeout(() => window.cartDrawer.open(), 300);
        }
        
        // Track event
        if (typeof gtag !== 'undefined') {
          gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: item.final_price / 100,
            items: [{
              item_id: item.product_id,
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: item.final_price / 100,
              quantity: item.quantity
            }],
            source: 'sticky_header'
          });
        }
        
        // Reset button after delay
        setTimeout(() => {
          button.classList.remove('is-success');
          buttonText.innerHTML = `
            <span class="text-desktop">Add to Cart</span>
            <span class="text-mobile">Add</span>
          `;
          buttonText.style.display = 'inline-flex';
          buttonLoading.style.display = 'none';
          button.disabled = false;
        }, 2000);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      
      // Error state
      buttonLoading.style.display = 'none';
      buttonText.style.display = 'inline-flex';
      buttonText.textContent = 'Error - Try Again';
      button.classList.add('is-error');
      
      setTimeout(() => {
        button.classList.remove('is-error');
        buttonText.innerHTML = `
          <span class="text-desktop">Add to Cart</span>
          <span class="text-mobile">Add</span>
        `;
        buttonText.style.display = 'inline-flex';
        buttonLoading.style.display = 'none';
        button.disabled = false;
      }, 2000);
    }
  }
  
  toggleWishlist(e) {
    const button = e.currentTarget;
    const isActive = button.classList.contains('is-active');
    
    button.classList.toggle('is-active');
    
    // TODO: Implement actual wishlist functionality
    // This would typically make an API call to add/remove from wishlist
    
    // Track event
    if (typeof gtag !== 'undefined') {
      gtag('event', isActive ? 'remove_from_wishlist' : 'add_to_wishlist', {
        item_id: this.header.dataset.productId,
        source: 'sticky_header'
      });
    }
  }
  
  handleVariantChange(e) {
    const select = e.target;
    const selectedOption = select.options[select.selectedIndex];
    const variantId = selectedOption.value;
    const price = selectedOption.dataset.price;
    const comparePrice = selectedOption.dataset.comparePrice;
    const available = !selectedOption.disabled;
    
    // Update hidden input
    const variantInput = this.header.querySelector('[data-variant-id]');
    if (variantInput) {
      variantInput.value = variantId;
    }
    
    // Update prices
    this.updatePrices(price, comparePrice);
    
    // Update button state
    const addToCartBtn = this.header.querySelector('[data-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.disabled = !available;
      const buttonText = addToCartBtn.querySelector('.button__text');
      if (buttonText) {
        buttonText.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    }
    
    // Dispatch event for other components
    document.dispatchEvent(new CustomEvent('sticky-header:variant-change', {
      detail: {
        variantId: variantId,
        available: available,
        price: price,
        comparePrice: comparePrice
      }
    }));
  }
  
  syncVariant(e) {
    const variant = e.detail.variant;
    if (!variant) return;
    
    // Update variant selector
    const variantSelect = this.header.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.value = variant.id;
    }
    
    // Update hidden input
    const variantInput = this.header.querySelector('[data-variant-id]');
    if (variantInput) {
      variantInput.value = variant.id;
    }
    
    // Update prices
    this.updatePrices(
      variant.price,
      variant.compare_at_price || null
    );
    
    // Update button state
    const addToCartBtn = this.header.querySelector('[data-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      const buttonText = addToCartBtn.querySelector('.button__text');
      if (buttonText) {
        buttonText.innerHTML = variant.available 
          ? '<span class="text-desktop">Add to Cart</span><span class="text-mobile">Add</span>'
          : 'Sold Out';
      }
    }
  }
  
  // price and comparePrice are in cents
  updatePrices(price, comparePrice) {
    const priceCents = Number(price);
    const compareCents = comparePrice == null ? null : Number(comparePrice);
    // Update current price
    const currentPriceEl = this.header.querySelector('[data-price-current]');
    if (currentPriceEl) {
      currentPriceEl.textContent = money(priceCents);
    }
    
    // Update compare price
    const comparePriceEl = this.header.querySelector('[data-price-compare]');
    if (comparePriceEl) {
      if (compareCents && compareCents > priceCents) {
        comparePriceEl.textContent = money(compareCents);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    
    // Update savings badge
    const savingsBadge = this.header.querySelector('[data-savings-badge]');
    if (savingsBadge) {
      if (compareCents && compareCents > priceCents) {
        const savings = compareCents - priceCents;
        const savingsPercentage = Math.round((savings / compareCents) * 100);
        savingsBadge.textContent = `Save ${money(savings)} (${savingsPercentage}%)`;
        savingsBadge.style.display = 'inline-flex';
      } else {
        savingsBadge.style.display = 'none';
      }
    }
    
    // Update button price
    const buttonPrice = this.header.querySelector('.button__price');
    if (buttonPrice) {
      buttonPrice.textContent = money(priceCents);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductStickyHeader();
});
;
/* product-info-sidebar.js */
// Format a price in cents using the shopper's active currency
// (window.formatMoney comes from money-format.js)
function money(cents) {
  return window.formatMoney ? window.formatMoney(cents) : '$' + (Number(cents) / 100).toFixed(2);
}

class ProductInfoSidebar {
  constructor(element) {
    this.container = element;
    this.form = element.querySelector('[data-product-form]');
    this.variantSelectors = element.querySelectorAll('[data-option-value]');
    this.quantityInput = element.querySelector('[data-quantity-input]');
    this.addToCartButton = element.querySelector('[data-add-to-cart]');
    this.productId = element.dataset.productId;
    
    // Get product data from the page
    this.productData = this.getProductData();
    
    this.init();
  }
  
  init() {
    // Variant selection
    this.initVariantSelection();
    
    // Quantity controls
    this.initQuantityControls();
    
    // Form submission
    this.initFormSubmission();
    
    // Wishlist
    this.initWishlist();
    
    // Payment info
    this.initPaymentInfo();
    
    // Shipping calculator - Commented Out
    // this.initShippingCalculator();
    
    // Reviews link smooth scroll
    this.initReviewsLink();

    // Trust video player
  }
  
  getProductData() {
    // Try to get product data from the Shopify script tag
    const productScript = document.querySelector('script[data-product-json]');
    if (productScript) {
      try {
        return JSON.parse(productScript.textContent);
      } catch (e) {
        console.error('Failed to parse product data:', e);
      }
    }
    
    // Fallback: build basic product data from the page
    return {
      id: this.productId,
      variants: this.buildVariantsFromPage()
    };
  }
  
  buildVariantsFromPage() {
    // This is a simplified version - in production, you'd have proper variant data
    const variants = [];
    const currentVariantId = this.form.querySelector('[data-variant-id]').value;
    
    variants.push({
      id: currentVariantId,
      available: true,
      price: this.getPriceFromPage(),
      compare_at_price: this.getComparePriceFromPage()
    });
    
    return variants;
  }
  
  getPriceFromPage() {
    const priceEl = this.container.querySelector('[data-price-current]');
    if (!priceEl || !priceEl.textContent) return 0;
    return parseFloat(priceEl.textContent.replace('$', '')) * 100;
  }
  
  getComparePriceFromPage() {
    const priceEl = this.container.querySelector('[data-price-compare]');
    if (!priceEl || !priceEl.textContent) return null;
    return parseFloat(priceEl.textContent.replace('$', '')) * 100;
  }
  
  initVariantSelection() {
    this.variantSelectors.forEach(selector => {
      selector.addEventListener('change', this.onVariantChange.bind(this));
    });
  }
  
  onVariantChange() {
    // Get selected options
    const selectedOptions = [];
    this.container.querySelectorAll('.variant-selector').forEach(selector => {
      const checkedInput = selector.querySelector('input:checked');
      if (checkedInput) {
        selectedOptions.push(checkedInput.value);
      }
    });
    
    // Find matching variant
    const variant = this.findVariantFromOptions(selectedOptions);
    
    if (variant) {
      this.updateForVariant(variant);
      
      // Dispatch event for other components
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { variant: variant }
      }));
    }
  }
  
  findVariantFromOptions(options) {
    // In a real implementation, this would search through product.variants
    // For now, return the first variant
    return this.productData.variants[0];
  }
  
  updateForVariant(variant) {
    // Update variant ID
    const variantInput = this.form.querySelector('[data-variant-id]');
    variantInput.value = variant.id;
    
    // Update prices
    this.updatePrices(variant);
    
    // Update availability
    this.updateAvailability(variant);
    
    // Update selected value displays
    this.updateSelectedValues();
  }
  
  updatePrices(variant) {
    const currentPriceEl = this.container.querySelector('[data-price-current]');
    const comparePriceEl = this.container.querySelector('[data-price-compare]');
    const savingsBadge = this.container.querySelector('[data-savings-badge]');
    const addToCartButton = this.container.querySelector('[data-add-to-cart] .button__text');
    
    // Update current price
    const price = money(variant.price);
    currentPriceEl.textContent = price;
    
    // Update add to cart button price
    if (variant.available && addToCartButton) {
      addToCartButton.textContent = `Add to Cart - ${price}`;
    }
    
    // Update compare price and savings
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const comparePrice = money(variant.compare_at_price);
      const savings = money(variant.compare_at_price - variant.price);
      const savingsPercentage = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      
      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.style.display = 'inline';
      }
      
      if (savingsBadge) {
        savingsBadge.textContent = `Save ${savings} (${savingsPercentage}%)`;
        savingsBadge.style.display = 'inline-flex';
      }
    } else {
      if (comparePriceEl) comparePriceEl.style.display = 'none';
      if (savingsBadge) savingsBadge.style.display = 'none';
    }
  }
  
  updateAvailability(variant) {
    const addToCartButton = this.container.querySelector('[data-add-to-cart]');
    const buttonText = addToCartButton.querySelector('.button__text');
    const stockStatus = this.container.querySelector('[data-stock-status]');
    
    if (variant.available) {
      addToCartButton.disabled = false;
      buttonText.textContent = `Add to Cart - ${money(variant.price)}`;
      
      // Update stock status
      if (stockStatus) {
        if (variant.inventory_quantity && variant.inventory_quantity <= 10) {
          stockStatus.innerHTML = `
            <span class="stock-status__low">
              <svg class="icon icon--alert" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 1L13 12H1L7 1Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M7 5V8M7 10V10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              Only ${variant.inventory_quantity} left in stock
            </span>
          `;
        } else {
          stockStatus.innerHTML = `
            <span class="stock-status__available">
              <svg class="icon icon--check-circle" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
                <path d="M4 7L6 9L10 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              In Stock
            </span>
          `;
        }
      }
    } else {
      addToCartButton.disabled = true;
      buttonText.textContent = 'Sold Out';
      
      if (stockStatus) {
        stockStatus.innerHTML = `
          <span class="stock-status__out">
            <svg class="icon icon--x-circle" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
              <path d="M5 5L9 9M9 5L5 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            Out of Stock
          </span>
        `;
      }
    }
  }
  
  updateSelectedValues() {
    this.container.querySelectorAll('.variant-selector').forEach(selector => {
      const valueDisplay = selector.querySelector('[data-selected-value]');
      const checkedInput = selector.querySelector('input:checked');
      
      if (valueDisplay && checkedInput) {
        valueDisplay.textContent = checkedInput.value;
      }
    });
  }
  
  initQuantityControls() {
    const minusBtn = this.container.querySelector('[data-quantity-minus]');
    const plusBtn = this.container.querySelector('[data-quantity-plus]');
    
    minusBtn?.addEventListener('click', () => this.adjustQuantity(-1));
    plusBtn?.addEventListener('click', () => this.adjustQuantity(1));
    
    this.quantityInput?.addEventListener('change', () => this.validateQuantity());
  }
  
  adjustQuantity(delta) {
    const current = parseInt(this.quantityInput.value) || 1;
    const min = parseInt(this.quantityInput.min) || 1;
    const max = parseInt(this.quantityInput.max) || 999;
    
    const newValue = Math.max(min, Math.min(max, current + delta));
    this.quantityInput.value = newValue;
    
    // Trigger change event
    this.quantityInput.dispatchEvent(new Event('change'));
  }
  
  validateQuantity() {
    const value = parseInt(this.quantityInput.value) || 1;
    const min = parseInt(this.quantityInput.min) || 1;
    const max = parseInt(this.quantityInput.max) || 999;
    
    this.quantityInput.value = Math.max(min, Math.min(max, value));
  }
  
  initFormSubmission() {
    // Disabled to prevent conflicts with add-to-cart-simple.js
    // this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
  }
  
  async handleFormSubmit(e) {
    e.preventDefault();
    
    const button = this.addToCartButton;
    const buttonText = button.querySelector('.button__text');
    const buttonLoading = button.querySelector('.button__loading');
    const buttonSuccess = button.querySelector('.button__success');
    
    // Loading state
    button.disabled = true;
    if (buttonText) buttonText.style.display = 'none';
    if (buttonLoading) buttonLoading.style.display = 'inline-flex';
    
    try {
      const formData = new FormData(this.form);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        const item = await response.json();
        
        // Success state
        if (buttonLoading) buttonLoading.style.display = 'none';
        if (buttonSuccess) buttonSuccess.style.display = 'inline-flex';
        
        // Update cart drawer if it exists
        if (window.cartDrawer) {
          window.cartDrawer.updateCart();
          setTimeout(() => window.cartDrawer.open(), 300);
        }
        
        // Track event
        if (typeof gtag !== 'undefined') {
          gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: item.final_price / 100,
            items: [{
              item_id: item.product_id,
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: item.final_price / 100,
              quantity: item.quantity
            }]
          });
        }
        
        // Reset after delay
        setTimeout(() => {
          if (buttonSuccess) buttonSuccess.style.display = 'none';
          if (buttonText) buttonText.style.display = 'inline-flex';
          button.disabled = false;
          
          // Reset quantity
          if (this.quantityInput) this.quantityInput.value = 1;
        }, 3000);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      
      // Error state
      if (buttonLoading) buttonLoading.style.display = 'none';
      if (buttonText) {
        buttonText.style.display = 'inline-flex';
        buttonText.textContent = 'Error - Try Again';
      }
      
      setTimeout(() => {
        const priceEl = this.container.querySelector('[data-price-current]');
        if (buttonText && priceEl) {
          buttonText.textContent = `Add to Cart - ${priceEl.textContent}`;
        }
        button.disabled = false;
      }, 2000);
    }
  }
  
  initWishlist() {
    const wishlistBtn = this.container.querySelector('[data-wishlist-toggle]');
    if (!wishlistBtn) return;
    
    wishlistBtn.addEventListener('click', () => {
      wishlistBtn.classList.toggle('is-active');
      
      // TODO: Implement actual wishlist functionality
      // This would typically make an API call to add/remove from wishlist
      
      const isActive = wishlistBtn.classList.contains('is-active');
      
      // Update button text
      const btnText = isActive ? 'Remove from Wishlist' : 'Add to Wishlist';
      wishlistBtn.innerHTML = `
        <svg class="icon icon--heart" width="20" height="20" viewBox="0 0 20 20" fill="${isActive ? 'currentColor' : 'none'}">
          <path d="M17.367 3.842a4.583 4.583 0 00-6.484 0L10 4.725l-.883-.883a4.584 4.584 0 00-6.484 6.484l.884.883L10 17.692l6.483-6.483.884-.883a4.584 4.584 0 000-6.484z" 
                stroke="currentColor" 
                stroke-width="1.5" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
        </svg>
        ${btnText}
      `;
      
      // Track event
      if (typeof gtag !== 'undefined') {
        gtag('event', isActive ? 'add_to_wishlist' : 'remove_from_wishlist', {
          item_id: this.productId
        });
      }
    });
  }
  
  initPaymentInfo() {
    const paymentInfoBtn = this.container.querySelector('[data-payment-info]');
    if (!paymentInfoBtn) return;
    
    paymentInfoBtn.addEventListener('click', () => {
      alert('Payment plans available through Shop Pay at checkout');
    });
  }
  
  initShippingCalculator() {
    const calculator = this.container.querySelector('[data-shipping-calculator]');
    if (!calculator) return;
    
    calculator.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const zipInput = calculator.querySelector('[data-shipping-zip]');
      const resultsDiv = this.container.querySelector('[data-shipping-results]');
      const zip = zipInput.value.trim();
      
      if (!zip || !/^\d{5}$/.test(zip)) {
        resultsDiv.innerHTML = '<p class="error">Please enter a valid 5-digit ZIP code</p>';
        resultsDiv.style.display = 'block';
        return;
      }
      
      // Show loading
      resultsDiv.innerHTML = '<p class="shipping-loading"><i class="fas fa-spinner fa-spin"></i> Calculating shipping rates...</p>';
      resultsDiv.style.display = 'block';
      
      // Show estimated rates after brief delay
      setTimeout(() => {
        resultsDiv.innerHTML = `
          <div class="shipping-rates">
            <h4>Shipping to ${zip}:</h4>
            <div class="rate rate--free">
              <div class="rate__header">
                <strong>Free Standard Shipping</strong>
                <span class="rate__price">FREE</span>
              </div>
              <span class="rate__delivery">5-7 business days</span>
            </div>
            <div class="rate">
              <div class="rate__header">
                <strong>Express Shipping</strong>
                <span class="rate__price">$12.99</span>
              </div>
              <span class="rate__delivery">2-3 business days</span>
            </div>
            <div class="rate">
              <div class="rate__header">
                <strong>Overnight Shipping</strong>
                <span class="rate__price">$29.99</span>
              </div>
              <span class="rate__delivery">Next business day</span>
            </div>
          </div>
          <p class="shipping-note"><small>* Rates shown are estimates. Final shipping will be calculated at checkout.</small></p>
        `;
      }, 800);
    });
  }

  
  initReviewsLink() {
    const reviewsLink = this.container.querySelector('a[href="#reviews"]');
    if (!reviewsLink) return;

    reviewsLink.addEventListener('click', (e) => {
      e.preventDefault();
      const reviewsSection = document.getElementById('reviews');
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const productInfos = document.querySelectorAll('[data-product-info]');
  productInfos.forEach(info => new ProductInfoSidebar(info));
});
;
/* product-description-tabs.js */
class ProductTabs {
  constructor(element) {
    this.container = element;
    this.tabButtons = element.querySelectorAll('[role="tab"]');
    this.tabPanels = element.querySelectorAll('[role="tabpanel"]');
    this.accordionTriggers = element.querySelectorAll('[data-accordion-trigger]');
    this.accordionContents = element.querySelectorAll('[data-accordion-content]');
    this.productId = element.dataset.productId;
    
    this.init();
  }
  
  init() {
    // Desktop tab clicks
    this.tabButtons.forEach(button => {
      button.addEventListener('click', this.onTabClick.bind(this));
    });
    
    // Keyboard navigation for tabs
    this.container.addEventListener('keydown', this.onKeyDown.bind(this));
    
    // Mobile accordion
    this.initMobileAccordion();
    
    // Handle deep linking
    this.handleDeepLink();
    
    // Track time on tabs
    this.initTabTracking();
  }
  
  onTabClick(e) {
    const button = e.currentTarget;
    const targetId = button.getAttribute('aria-controls');
    
    this.showTab(targetId);
    
    // Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'view_product_tab', {
        tab_name: button.textContent.trim(),
        product_id: this.productId
      });
    }
  }
  
  showTab(tabId) {
    // Hide all panels
    this.tabPanels.forEach(panel => {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    });
    
    // Deactivate all buttons
    this.tabButtons.forEach(button => {
      button.setAttribute('aria-selected', 'false');
      button.classList.remove('is-active');
    });
    
    // Show target panel
    const targetPanel = document.getElementById(tabId);
    const targetButton = document.querySelector(`[aria-controls="${tabId}"]`);
    
    if (targetPanel && targetButton) {
      targetPanel.classList.add('is-active');
      targetPanel.setAttribute('aria-hidden', 'false');
      targetButton.setAttribute('aria-selected', 'true');
      targetButton.classList.add('is-active');
      
      // Update URL without scrolling
      const tabName = tabId.split('-')[1]; // Extract tab name from ID
      history.replaceState(null, null, `#${tabName}`);
      
      // Start tracking time on this tab
      this.startTabTracking(targetButton.textContent.trim());
    }
  }
  
  onKeyDown(e) {
    // Only handle arrow keys on tab buttons
    if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
    if (!e.target.matches('[role="tab"]')) return;
    
    e.preventDefault();
    
    const currentButton = e.target;
    const buttons = Array.from(this.tabButtons);
    const currentIndex = buttons.indexOf(currentButton);
    
    let nextIndex;
    if (e.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % buttons.length;
    } else {
      nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    }
    
    const nextButton = buttons[nextIndex];
    nextButton.focus();
    nextButton.click();
  }
  
  initMobileAccordion() {
    this.accordionTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const content = this.accordionContents[index];
        
        if (isExpanded) {
          // Close
          trigger.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
          content.style.maxHeight = '0';
        } else {
          // Close all others first
          this.accordionTriggers.forEach((otherTrigger, otherIndex) => {
            if (otherIndex !== index) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              this.accordionContents[otherIndex].setAttribute('aria-hidden', 'true');
              this.accordionContents[otherIndex].style.maxHeight = '0';
            }
          });
          
          // Open this one
          trigger.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
          
          // Calculate and set max-height for smooth animation
          const scrollHeight = content.scrollHeight;
          content.style.maxHeight = scrollHeight + 'px';
          
          // Analytics
          if (typeof gtag !== 'undefined') {
            gtag('event', 'view_product_accordion', {
              accordion_name: trigger.querySelector('span').textContent.trim(),
              product_id: this.productId
            });
          }
        }
      });
    });
    
    // Set initial heights for open accordions
    this.accordionContents.forEach((content, index) => {
      if (this.accordionTriggers[index].getAttribute('aria-expanded') === 'true') {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }
  
  handleDeepLink() {
    const hash = window.location.hash;
    if (!hash) return;
    
    const tabName = hash.substring(1); // Remove #
    const validTabs = ['overview', 'specifications', 'warranty', 'shipping'];
    
    if (validTabs.includes(tabName)) {
      // Find the tab button for this section
      const tabButton = Array.from(this.tabButtons).find(button => {
        const controlsId = button.getAttribute('aria-controls');
        return controlsId && controlsId.includes(`tab-${tabName}`);
      });
      
      if (tabButton) {
        // Small delay to ensure everything is loaded
        setTimeout(() => {
          tabButton.click();
          
          // Scroll to tabs section
          this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }
  
  initTabTracking() {
    this.tabStartTime = Date.now();
    this.currentTab = 'Overview'; // Default starting tab
  }
  
  startTabTracking(tabName) {
    // Track time spent on previous tab
    if (this.currentTab) {
      const timeSpent = Date.now() - this.tabStartTime;
      
      if (typeof gtag !== 'undefined' && timeSpent > 1000) { // Only track if > 1 second
        gtag('event', 'tab_engagement', {
          product_id: this.productId,
          tab_name: this.currentTab,
          time_spent_seconds: Math.round(timeSpent / 1000)
        });
      }
    }
    
    // Start tracking new tab
    this.currentTab = tabName;
    this.tabStartTime = Date.now();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const productTabs = document.querySelectorAll('[data-product-tabs]');
  productTabs.forEach(tabs => new ProductTabs(tabs));
  
  // Handle spec sheet downloads
  document.addEventListener('click', (e) => {
    if (e.target.matches('a[download]')) {
      const fileName = e.target.getAttribute('download') || 'file';
      const productId = e.target.closest('[data-product-tabs]')?.dataset.productId;
      
      if (typeof gtag !== 'undefined') {
        gtag('event', 'download_spec_sheet', {
          product_id: productId,
          file_name: fileName
        });
      }
    }
  });
});
;
/* product-tech-specs.js */
class TechSpecsViewer {
  constructor(element) {
    this.container = element;
    this.viewer = element.querySelector('[data-device-viewer]');
    this.images = element.querySelectorAll('.device-image');
    this.indicators = element.querySelectorAll('.indicator');
    this.hotspots = element.querySelectorAll('.hotspot');
    this.currentAngle = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    
    this.init();
  }
  
  init() {
    // Check if viewer exists (may not be present on all pages)
    if (this.viewer) {
      // Rotation controls
      const prevBtn = this.viewer.querySelector('[data-rotate="prev"]');
      const nextBtn = this.viewer.querySelector('[data-rotate="next"]');

      if (prevBtn) prevBtn.addEventListener('click', () => this.rotate(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.rotate(1));

      // Indicator clicks
      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => this.showAngle(index));
      });

      // Touch/swipe support
      this.initTouchRotation();

      // Keyboard navigation
      this.viewer.addEventListener('keydown', this.handleKeyboard.bind(this));

      // Hotspot interactions
      this.initHotspots();
    }
    
    // Animated counters
    this.initCounters();
    
    // Progress bars
    this.initProgressBars();
    
    // Intersection observer for animations
    this.initAnimations();
  }
  
  rotate(direction) {
    const totalImages = this.images.length;
    const newAngle = (this.currentAngle + direction + totalImages) % totalImages;
    this.showAngle(newAngle);
  }
  
  showAngle(angleIndex) {
    // Hide current
    if (this.images[this.currentAngle]) {
      this.images[this.currentAngle].classList.remove('is-active');
    }
    if (this.indicators[this.currentAngle]) {
      this.indicators[this.currentAngle].classList.remove('is-active');
    }
    
    // Update angle
    this.currentAngle = angleIndex;
    
    // Show new
    if (this.images[this.currentAngle]) {
      this.images[this.currentAngle].classList.add('is-active');
    }
    if (this.indicators[this.currentAngle]) {
      this.indicators[this.currentAngle].classList.add('is-active');
    }
    
    // Analytics
    if (typeof gtag !== 'undefined') {
      gtag('event', 'interact_device_viewer', {
        interaction_type: 'rotate',
        angle: this.currentAngle
      });
    }
  }
  
  initTouchRotation() {
    const imageContainer = this.viewer.querySelector('.device-images');
    if (!imageContainer) return;
    
    imageContainer.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    imageContainer.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    }, { passive: true });
  }
  
  handleSwipe() {
    const swipeThreshold = 50;
    const diff = this.touchStartX - this.touchEndX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next image
        this.rotate(1);
      } else {
        // Swipe right - previous image
        this.rotate(-1);
      }
    }
  }
  
  handleKeyboard(e) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.rotate(-1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.rotate(1);
    }
  }
  
  initHotspots() {
    this.hotspots.forEach(hotspot => {
      const tooltip = document.createElement('div');
      tooltip.className = 'hotspot-tooltip';
      tooltip.textContent = hotspot.dataset.tooltip;
      tooltip.setAttribute('role', 'tooltip');
      hotspot.appendChild(tooltip);
      
      // Show/hide tooltip
      hotspot.addEventListener('mouseenter', () => {
        tooltip.classList.add('is-visible');
      });
      
      hotspot.addEventListener('mouseleave', () => {
        tooltip.classList.remove('is-visible');
      });
      
      // Mobile tap
      hotspot.addEventListener('click', (e) => {
        e.preventDefault();
        tooltip.classList.toggle('is-visible');
        
        // Hide other tooltips
        this.hotspots.forEach(other => {
          if (other !== hotspot) {
            other.querySelector('.hotspot-tooltip')?.classList.remove('is-visible');
          }
        });
      });
    });
    
    // Close tooltips when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.hotspot')) {
        document.querySelectorAll('.hotspot-tooltip').forEach(tooltip => {
          tooltip.classList.remove('is-visible');
        });
      }
    });
  }
  
  initCounters() {
    const counters = this.container.querySelectorAll('[data-counter]');
    
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    
    counters.forEach(counter => observer.observe(counter));
  }
  
  animateCounter(element) {
    const target = parseInt(element.dataset.counter);
    const duration = 1500;
    const start = Date.now();
    const startValue = 0;
    
    const update = () => {
      const elapsed = Date.now() - start;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const current = Math.floor(startValue + (target - startValue) * easeOutQuart);
      
      element.textContent = current.toLocaleString();
      
      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };
    
    requestAnimationFrame(update);
  }
  
  initProgressBars() {
    const progressBars = this.container.querySelectorAll('[data-progress]');
    
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const bar = entry.target;
          const progress = bar.dataset.progress;
          setTimeout(() => {
            bar.style.width = progress + '%';
          }, 100);
          observer.unobserve(bar);
        }
      });
    }, { threshold: 0.1 });
    
    progressBars.forEach(bar => observer.observe(bar));
  }
  
  initAnimations() {
    // Animate spec categories on scroll
    const categories = this.container.querySelectorAll('.spec-category');
    
    const observer = new IntersectionObserver(entries => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, index * 100);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    
    categories.forEach(category => observer.observe(category));
  }
}

// Comparison table enhancements
class ComparisonTable {
  constructor(element) {
    this.table = element;
    this.init();
  }
  
  init() {
    // Add visual indicators for better values
    this.highlightBestValues();
    
    // Make table scrollable on mobile with indicators
    this.initMobileScroll();
  }
  
  highlightBestValues() {
    const rows = this.table.querySelectorAll('tbody tr');
    
    rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      const values = Array.from(cells).slice(1); // Skip first cell (feature name)
      
      // Find best value (simplified logic - customize as needed)
      let bestIndex = 0;
      let bestValue = this.extractNumericValue(values[0].textContent);
      
      values.forEach((cell, index) => {
        const value = this.extractNumericValue(cell.textContent);
        if (value > bestValue) {
          bestValue = value;
          bestIndex = index;
        }
      });
      
      // Add visual indicator to best value
      if (values[bestIndex]) {
        values[bestIndex].classList.add('best-value');
      }
    });
  }
  
  extractNumericValue(text) {
    const match = text.match(/[\d.]+/);
    return match ? parseFloat(match[0]) : 0;
  }
  
  initMobileScroll() {
    const wrapper = this.table.closest('.table-scroll');
    if (!wrapper) return;
    
    // Add scroll indicators
    const scrollIndicator = document.createElement('div');
    scrollIndicator.className = 'scroll-indicator';
    scrollIndicator.innerHTML = '← Scroll to compare →';
    wrapper.appendChild(scrollIndicator);
    
    // Hide indicator when scrolled
    wrapper.addEventListener('scroll', () => {
      if (wrapper.scrollLeft > 10) {
        scrollIndicator.style.opacity = '0';
      } else {
        scrollIndicator.style.opacity = '1';
      }
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Tech specs viewers
  const techSpecs = document.querySelectorAll('[data-tech-specs]');
  techSpecs.forEach(spec => new TechSpecsViewer(spec));
  
  // Comparison tables
  const comparisonTables = document.querySelectorAll('.comparison-table');
  comparisonTables.forEach(table => new ComparisonTable(table));
  
  // Track PDF downloads
  document.addEventListener('click', (e) => {
    const downloadLink = e.target.closest('a[download]');
    if (downloadLink && downloadLink.href.includes('.pdf')) {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'download_specs', {
          file_name: downloadLink.getAttribute('download'),
          file_type: 'pdf'
        });
      }
    }
  });
  
  // Track section visibility
  const specSection = document.querySelector('.tech-specs');
  if (specSection) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'view_tech_specs', {
              section_viewed: 'specifications'
            });
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    
    observer.observe(specSection);
  }
});
;
/* product-benefits-grid.js */
// Format a price in cents using the shopper's active currency
// (window.formatMoney comes from money-format.js)
function money(cents) {
  return window.formatMoney ? window.formatMoney(cents) : '$' + (Number(cents) / 100).toFixed(2);
}

class ProductBenefits {
  constructor(element) {
    this.section = element;
    this.cards = element.querySelectorAll('.benefit-card');
    this.counters = element.querySelectorAll('[data-counter]');
    this.charts = element.querySelectorAll('[data-chart]');
    
    this.init();
  }
  
  init() {
    // Scroll animations
    this.initScrollAnimations();
    
    // Counter animations
    this.initCounters();
    
    // Interactive calculators
    this.initCalculators();
    
    // Performance charts
    this.initCharts();
    
    // Track section view
    this.trackSectionView();
  }
  
  initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('is-visible');
            
            // Animate icon
            const icon = entry.target.querySelector('.benefit-card__icon');
            if (icon) {
              this.animateIcon(icon);
            }
            
            // Track benefit view
            this.trackBenefitView(entry.target);
          }, index * 100);
          
          observer.unobserve(entry.target);
        }
      });
    }, { 
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    });
    
    this.cards.forEach(card => observer.observe(card));
  }
  
  animateIcon(iconElement) {
    iconElement.animate([
      { transform: 'scale(0) rotate(-180deg)', opacity: 0 },
      { transform: 'scale(1.2) rotate(10deg)', opacity: 1, offset: 0.6 },
      { transform: 'scale(1) rotate(0deg)', opacity: 1 }
    ], {
      duration: 600,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      fill: 'forwards'
    });
  }
  
  initCounters() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    
    this.counters.forEach(counter => observer.observe(counter));
  }
  
  animateCounter(element) {
    const target = parseFloat(element.dataset.counter);
    const duration = 2000;
    const start = Date.now();
    const isDecimal = target % 1 !== 0;
    const isLarge = target > 1000;
    
    const update = () => {
      const progress = Math.min((Date.now() - start) / duration, 1);
      const current = target * this.easeOutCubic(progress);
      
      if (isDecimal) {
        element.textContent = current.toFixed(1);
      } else if (isLarge) {
        element.textContent = Math.floor(current).toLocaleString();
      } else {
        element.textContent = Math.floor(current);
      }
      
      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        // Ensure final value is exact
        if (isDecimal) {
          element.textContent = target.toFixed(1);
        } else if (isLarge) {
          element.textContent = target.toLocaleString();
        } else {
          element.textContent = target;
        }
      }
    };
    
    requestAnimationFrame(update);
  }
  
  easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }
  
  initCalculators() {
    const calculatorButtons = this.section.querySelectorAll('[data-savings-modal]');
    
    calculatorButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.openSavingsModal();
      });
    });
  }
  
  openSavingsModal() {
    // Create modal if it doesn't exist
    let modal = document.getElementById('savings-calculator-modal');
    if (!modal) {
      modal = this.createSavingsModal();
      document.body.appendChild(modal);
    }
    
    // Show modal
    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    
    // Track interaction
    if (typeof gtag !== 'undefined') {
      gtag('event', 'open_savings_calculator', {
        product_id: this.section.dataset.productId
      });
    }
  }
  
  createSavingsModal() {
    const modal = document.createElement('div');
    modal.id = 'savings-calculator-modal';
    modal.className = 'savings-modal';
    modal.innerHTML = `
      <div class="savings-modal__overlay"></div>
      <div class="savings-modal__content">
        <button class="savings-modal__close" aria-label="Close calculator">×</button>
        <h3>Calculate Your Savings</h3>
        <form class="savings-form">
          <div class="form-group">
            <label for="wipes-per-month">How many packs of wipes do you buy per month?</label>
            <input type="number" id="wipes-per-month" value="4" min="1" max="20">
          </div>
          <div class="form-group">
            <label for="price-per-pack">Average price per pack:</label>
            <input type="number" id="price-per-pack" value="7.50" min="1" max="20" step="0.50">
          </div>
          <div class="results">
            <div class="result-row">
              <span>Monthly wipe cost:</span>
              <strong id="monthly-cost">$30</strong>
            </div>
            <div class="result-row">
              <span>Annual wipe cost:</span>
              <strong id="annual-cost">$360</strong>
            </div>
            <div class="result-row highlight">
              <span>You'll save:</span>
              <strong id="total-savings">$360/year</strong>
            </div>
          </div>
          <p class="savings-note">Rechargeable, with no refills or cartridges to buy after purchase.</p>
        </form>
      </div>
    `;
    
    // Add event listeners
    const overlay = modal.querySelector('.savings-modal__overlay');
    const closeBtn = modal.querySelector('.savings-modal__close');
    const inputs = modal.querySelectorAll('input');
    
    [overlay, closeBtn].forEach(el => {
      el.addEventListener('click', () => this.closeSavingsModal());
    });
    
    inputs.forEach(input => {
      input.addEventListener('input', () => this.updateSavingsCalculation(modal));
    });
    
    // Initial calculation
    this.updateSavingsCalculation(modal);
    
    return modal;
  }
  
  updateSavingsCalculation(modal) {
    const wipesPerMonth = parseFloat(modal.querySelector('#wipes-per-month').value) || 0;
    const pricePerPack = parseFloat(modal.querySelector('#price-per-pack').value) || 0;
    
    const monthlyCost = wipesPerMonth * pricePerPack;
    const annualCost = monthlyCost * 12;
    
    modal.querySelector('#monthly-cost').textContent = money(monthlyCost * 100);
    modal.querySelector('#annual-cost').textContent = money(annualCost * 100);
    modal.querySelector('#total-savings').textContent = `${money(Math.round(annualCost) * 100)}/year`;
  }
  
  closeSavingsModal() {
    const modal = document.getElementById('savings-calculator-modal');
    if (modal) {
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }
  
  initCharts() {
    this.charts.forEach(canvas => {
      const config = JSON.parse(canvas.dataset.chart);
      
      // Wait for element to be visible
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.drawChart(canvas, config);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      
      observer.observe(canvas);
    });
  }
  
  drawChart(canvas, config) {
    const ctx = canvas.getContext('2d');
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = Math.min(centerX, centerY) - 15;
    
    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    // Background circle
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
    ctx.strokeStyle = '#E8F4F8';
    ctx.lineWidth = 10;
    ctx.stroke();
    
    // Animated progress arc
    let currentProgress = 0;
    const targetProgress = config.value / 100;
    const animationDuration = 1500;
    const startTime = Date.now();
    
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / animationDuration, 1);
      currentProgress = targetProgress * this.easeOutCubic(progress);
      
      // Clear and redraw
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Background circle
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
      ctx.strokeStyle = '#E8F4F8';
      ctx.lineWidth = 10;
      ctx.stroke();
      
      // Progress arc
      const startAngle = -Math.PI / 2;
      const endAngle = startAngle + (2 * Math.PI * currentProgress);
      
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, startAngle, endAngle);
      ctx.strokeStyle = '#03045E';
      ctx.lineWidth = 10;
      ctx.lineCap = 'round';
      ctx.stroke();
      
      // Text
      ctx.font = 'bold 28px Inter, system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#121212';
      const displayValue = Math.floor(currentProgress * config.value);
      ctx.fillText(displayValue + '%', centerX, centerY);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure final value
        ctx.clearRect(centerX - 30, centerY - 20, 60, 40);
        ctx.fillText(config.value + '%', centerX, centerY);
      }
    };
    
    requestAnimationFrame(animate);
  }
  
  trackSectionView() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && typeof gtag !== 'undefined') {
          gtag('event', 'view_benefits_section', {
            product_id: this.section.dataset.productId
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    
    observer.observe(this.section);
  }
  
  trackBenefitView(card) {
    if (typeof gtag !== 'undefined') {
      const benefitType = card.dataset.benefitType;
      const benefitTitle = card.querySelector('.benefit-card__title')?.textContent;
      
      gtag('event', 'view_product_benefit', {
        product_id: this.section.dataset.productId,
        benefit_type: benefitType,
        benefit_title: benefitTitle
      });
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const benefitsSections = document.querySelectorAll('[data-benefits-grid]');
  benefitsSections.forEach(section => new ProductBenefits(section));
  
  // Track CTA clicks
  document.addEventListener('click', (e) => {
    const ctaLink = e.target.closest('.benefit-card__cta');
    if (ctaLink && typeof gtag !== 'undefined') {
      const card = ctaLink.closest('.benefit-card');
      gtag('event', 'click_benefit_cta', {
        product_id: card.closest('[data-product-id]')?.dataset.productId,
        benefit_type: card.dataset.benefitType,
        cta_text: ctaLink.textContent.trim()
      });
    }
  });
});
;
/* product-how-it-works.js */
class HowItWorks {
  constructor(element) {
    this.container = element;
    this.steps = element.querySelectorAll('.step-card');
    this.indicators = element.querySelectorAll('[data-step-indicator]');
    this.progressFill = element.querySelector('[data-progress-fill]');
    this.currentStep = 1;
    this.stepCount = this.steps.length;
    this.touchStartX = 0;
    this.touchEndX = 0;
    
    this.init();
  }
  
  init() {
    // Scroll animations
    this.initScrollAnimations();
    
    // Step interactions
    this.initStepInteractions();
    
    // Mobile swipe
    this.initMobileSwipe();
    
    // Video player
    this.initVideoPlayer();
    
    // Timer animation
    this.initTimerAnimation();
    
    // Track section view
    this.trackSectionView();
  }
  
  initScrollAnimations() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('is-visible');
            this.animateStep(entry.target);
            
            // Track step view
            this.trackStepView(entry.target);
          }, index * 200);
          
          observer.unobserve(entry.target);
        }
      });
    }, { 
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    });
    
    this.steps.forEach(step => observer.observe(step));
  }
  
  animateStep(stepElement) {
    const stepNumber = parseInt(stepElement.dataset.step);
    
    // Animate number circle
    const numberEl = stepElement.querySelector('.step-number');
    if (numberEl) {
      numberEl.animate([
        { transform: 'scale(0) rotate(-180deg)', opacity: 0 },
        { transform: 'scale(1.2) rotate(10deg)', opacity: 1, offset: 0.7 },
        { transform: 'scale(1) rotate(0deg)', opacity: 1 }
      ], {
        duration: 600,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        fill: 'forwards'
      });
    }
    
    // Update progress
    this.updateProgress(stepNumber);
    
    // Highlight previous steps
    this.highlightSteps(stepNumber);
    
    // Special animations for specific steps
    if (stepNumber === this.stepCount && stepElement.querySelector('[data-timer]')) {
      // Start timer for last step (if it has timer)
      setTimeout(() => this.startTimerAnimation(stepElement), 800);
    }
  }
  
  updateProgress(step) {
    if (this.progressFill) {
      const progress = (step / this.stepCount) * 100;
      this.progressFill.style.width = `${progress}%`;
    }
  }
  
  highlightSteps(upToStep) {
    this.steps.forEach((step, index) => {
      if (index < upToStep) {
        step.classList.add('is-highlighted');
      }
    });
  }
  
  initStepInteractions() {
    // Desktop hover effects
    this.steps.forEach(step => {
      step.addEventListener('mouseenter', () => {
        if (!step.classList.contains('is-complete')) {
          step.classList.add('is-hovered');
        }
      });
      
      step.addEventListener('mouseleave', () => {
        step.classList.remove('is-hovered');
      });
      
      // Click to replay animation
      step.addEventListener('click', () => {
        const stepNumber = parseInt(step.dataset.step);
        this.replayStepAnimation(step, stepNumber);
      });
    });
    
    // Mobile indicator clicks
    this.indicators.forEach(indicator => {
      indicator.addEventListener('click', () => {
        const stepNumber = parseInt(indicator.dataset.stepIndicator);
        this.scrollToStep(stepNumber);
        this.updateActiveIndicator(stepNumber);
      });
    });
  }
  
  replayStepAnimation(stepElement, stepNumber) {
    // Remove and re-add visible class to replay animation
    stepElement.classList.remove('is-visible');
    void stepElement.offsetWidth; // Force reflow
    stepElement.classList.add('is-visible');
    
    // Re-animate the step
    this.animateStep(stepElement);
  }
  
  scrollToStep(stepNumber) {
    const targetStep = this.steps[stepNumber - 1];
    if (targetStep) {
      targetStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
      
      // Track interaction
      this.trackStepInteraction(targetStep);
    }
  }
  
  updateActiveIndicator(stepNumber) {
    this.indicators.forEach((indicator, index) => {
      if (index + 1 === stepNumber) {
        indicator.classList.add('is-active');
      } else {
        indicator.classList.remove('is-active');
      }
    });
  }
  
  initMobileSwipe() {
    const stepsContainer = this.container.querySelector('.steps-grid');
    if (!stepsContainer) return;
    
    // Touch events for swipe
    stepsContainer.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    stepsContainer.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    }, { passive: true });
  }
  
  handleSwipe() {
    const swipeThreshold = 50;
    const diff = this.touchStartX - this.touchEndX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0 && this.currentStep < this.stepCount) {
        // Swipe left - next step
        this.currentStep++;
      } else if (diff < 0 && this.currentStep > 1) {
        // Swipe right - previous step
        this.currentStep--;
      }
      
      this.scrollToStep(this.currentStep);
      this.updateActiveIndicator(this.currentStep);
    }
  }
  
  startTimerAnimation(stepElement) {
    const timerEl = stepElement.querySelector('[data-timer]');
    if (!timerEl) return;
    
    // Show timer
    timerEl.style.display = 'flex';
    
    const circle = timerEl.querySelector('circle');
    const text = timerEl.querySelector('.timer-text');
    const circumference = 2 * Math.PI * 45;
    
    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference;
    
    // Start countdown
    let timeLeft = 30;
    const startTime = Date.now();
    
    const updateTimer = () => {
      const elapsed = (Date.now() - startTime) / 1000;
      const progress = Math.min(elapsed / 30, 1);
      
      // Update circle
      circle.style.strokeDashoffset = circumference * (1 - progress);
      
      // Update text
      timeLeft = Math.max(0, 30 - Math.floor(elapsed));
      text.textContent = timeLeft > 0 ? `${timeLeft}s` : '✓';
      
      if (progress < 1) {
        requestAnimationFrame(updateTimer);
      } else {
        // Complete animation
        this.showCompletion(stepElement);
      }
    };
    
    requestAnimationFrame(updateTimer);
  }
  
  showCompletion(stepElement) {
    stepElement.classList.add('is-complete');
    
    // Animate check mark
    const checkMark = stepElement.querySelector('.step-check');
    if (checkMark) {
      checkMark.style.opacity = '1';
      checkMark.style.transform = 'scale(1)';
    }
    
    // Create confetti effect
    this.createConfetti(stepElement);
    
    // Track completion
    if (typeof gtag !== 'undefined') {
      gtag('event', 'view_how_it_works_complete', {
        product_id: this.container.dataset.productId
      });
    }
  }
  
  createConfetti(element) {
    const colors = ['#03045E', '#023E8A', '#00C66B', '#023E8A'];
    const confettiCount = 20;
    const container = element.querySelector('.step-visual');
    
    for (let i = 0; i < confettiCount; i++) {
      const confetti = document.createElement('div');
      confetti.className = 'confetti';
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.left = `${Math.random() * 100}%`;
      confetti.style.animationDelay = `${Math.random() * 0.5}s`;
      confetti.style.animationDuration = `${2 + Math.random()}s`;
      container.appendChild(confetti);
      
      // Remove after animation
      setTimeout(() => confetti.remove(), 3000);
    }
  }
  
  initVideoPlayer() {
    const playButton = this.container.querySelector('[data-play-video]');
    const video = this.container.querySelector('[data-demo-video]');
    
    if (!playButton || !video) return;
    
    playButton.addEventListener('click', () => {
      playButton.style.display = 'none';
      video.play();
      
      // Track video play
      if (typeof gtag !== 'undefined') {
        gtag('event', 'play_how_it_works_video', {
          product_id: this.container.dataset.productId,
          video_duration: video.duration
        });
      }
    });
    
    // Show play button when video ends
    video.addEventListener('ended', () => {
      playButton.style.display = 'flex';
    });
    
    // Hide play button when video plays (from controls)
    video.addEventListener('play', () => {
      playButton.style.display = 'none';
    });
    
    // Show play button when video pauses
    video.addEventListener('pause', () => {
      if (video.currentTime < video.duration) {
        playButton.style.display = 'flex';
      }
    });
  }
  
  initTimerAnimation() {
    // Find all timer elements and prepare them
    const timers = this.container.querySelectorAll('[data-timer]');
    timers.forEach(timer => {
      const circle = timer.querySelector('circle');
      if (circle) {
        const circumference = 2 * Math.PI * 45;
        circle.style.strokeDasharray = circumference;
        circle.style.strokeDashoffset = circumference;
      }
    });
  }
  
  trackSectionView() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'view_how_it_works', {
        product_id: this.container.dataset.productId
      });
    }
  }
  
  trackStepView(stepElement) {
    if (typeof gtag !== 'undefined') {
      const stepNumber = stepElement.dataset.step;
      const stepTitle = stepElement.querySelector('.step-title')?.textContent;
      
      gtag('event', 'view_how_it_works_step', {
        product_id: this.container.dataset.productId,
        step_number: stepNumber,
        step_title: stepTitle
      });
    }
  }
  
  trackStepInteraction(stepElement) {
    if (typeof gtag !== 'undefined') {
      const stepNumber = stepElement.dataset.step;
      const stepTitle = stepElement.querySelector('.step-title')?.textContent;
      
      gtag('event', 'interact_how_it_works_step', {
        product_id: this.container.dataset.productId,
        step_number: stepNumber,
        step_title: stepTitle
      });
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const howItWorksSections = document.querySelectorAll('[data-how-it-works]');
  howItWorksSections.forEach(section => new HowItWorks(section));
  
  // Track resource clicks
  document.addEventListener('click', (e) => {
    const resourceCard = e.target.closest('.resource-card');
    if (resourceCard && typeof gtag !== 'undefined') {
      const resourceType = resourceCard.querySelector('h4')?.textContent;
      gtag('event', 'click_how_it_works_resource', {
        product_id: resourceCard.closest('[data-product-id]')?.dataset.productId,
        resource_type: resourceType
      });
    }
  });
});
;
/* product-sticky-cart.js */
// Sticky Cart Component
// Format a price in cents using the shopper's active currency
// (window.formatMoney comes from money-format.js)
function money(cents) {
  return window.formatMoney ? window.formatMoney(cents) : '$' + (Number(cents) / 100).toFixed(2);
}

class StickyCart {
  constructor(element) {
    this.element = element;
    this.productId = element.dataset.productId;
    this.mainButton = document.querySelector('.product-info-sidebar .add-to-cart, .product-actions .add-to-cart');
    this.mobileBar = element.querySelector('.sticky-cart__mobile');
    this.floatingCart = element.querySelector('.floating-cart');
    this.isVisible = false;
    this.isDismissed = this.checkDismissed();
    this.scrollThreshold = 300;
    this.lastScrollY = 0;

    this.init();
  }
  
  init() {
    if (this.isDismissed) return;
    
    // Check if enabled
    const isMobile = window.innerWidth < 768;
    if ((isMobile && !this.mobileBar) || (!isMobile && !this.floatingCart)) {
      return;
    }
    
    // Scroll detection
    this.initScrollDetection();
    
    // Quantity controls
    this.initQuantityControls();
    
    // Form submission
    this.initFormSubmission();
    
    // Floating cart interactions
    this.initFloatingCart();
    
    // Dismiss functionality
    this.initDismiss();
    
    // Variant changes
    this.initVariantSync();
    
    // Variant selector in sticky cart
    this.initVariantSelector();
    
    // Initial cart count
    this.updateCartCount();
  }
  
  initScrollDetection() {
    let scrollTimer;
    let ticking = false;
    
    const checkVisibility = () => {
      const scrollY = window.scrollY;
      const scrollDirection = scrollY > this.lastScrollY ? 'down' : 'up';
      this.lastScrollY = scrollY;
      
      // Get footer position
      const footer = document.querySelector('.site-footer, footer');
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const windowHeight = window.innerHeight;
      
      // Check if main button is visible
      let shouldShow = false;
      if (this.mainButton) {
        const buttonRect = this.mainButton.getBoundingClientRect();
        shouldShow = buttonRect.bottom < 0 || buttonRect.top > windowHeight;
      } else {
        // Fallback to scroll threshold
        shouldShow = scrollY > this.scrollThreshold;
      }
      
      // Don't show if too close to footer
      const nearFooter = footerTop < windowHeight + 100;
      shouldShow = shouldShow && !nearFooter;
      
      // Only show on scroll up on mobile for better UX
      if (window.innerWidth < 768 && scrollDirection === 'down' && scrollY > 500) {
        shouldShow = false;
      }
      
      if (shouldShow && !this.isVisible) {
        this.show();
      } else if (!shouldShow && this.isVisible) {
        this.hide();
      }
      
      ticking = false;
    };
    
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(checkVisibility);
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Initial check
    setTimeout(checkVisibility, 100);
  }
  
  show() {
    this.isVisible = true;
    this.element.style.transform = 'translateY(0)';
    document.body.classList.add('sticky-cart-visible');
    
    // Track appearance
    if (typeof gtag !== 'undefined') {
      gtag('event', 'show_sticky_cart', {
        product_id: this.productId,
        device_type: window.innerWidth < 768 ? 'mobile' : 'desktop',
        scroll_depth: Math.round((window.scrollY / document.documentElement.scrollHeight) * 100)
      });
    }
  }
  
  hide() {
    this.isVisible = false;
    this.element.style.transform = 'translateY(100%)';
    document.body.classList.remove('sticky-cart-visible');
  }
  
  initQuantityControls() {
    const adjustButtons = this.element.querySelectorAll('[data-qty-adjust]');
    const inputs = this.element.querySelectorAll('[data-qty-input]');
    const hiddenInputs = this.element.querySelectorAll('[data-qty-value]');
    
    adjustButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const adjustment = parseInt(btn.dataset.qtyAdjust);
        
        inputs.forEach(input => {
          const currentValue = parseInt(input.value) || 1;
          const maxValue = parseInt(input.max) || 999;
          const newValue = Math.max(1, Math.min(maxValue, currentValue + adjustment));
          
          input.value = newValue;
          
          // Update all quantity inputs
          inputs.forEach(i => i.value = newValue);
          hiddenInputs.forEach(h => h.value = newValue);
        });
      });
    });
    
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        const value = Math.max(1, parseInt(input.value) || 1);
        const maxValue = parseInt(input.max) || 999;
        const finalValue = Math.min(value, maxValue);
        
        // Sync all inputs
        inputs.forEach(i => i.value = finalValue);
        hiddenInputs.forEach(h => h.value = finalValue);
      });
    });
  }
  
  initFormSubmission() {
    const forms = this.element.querySelectorAll('[data-sticky-form]');
    
    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const button = form.querySelector('button[type="submit"]');
        const buttonText = button.querySelector('.button__text');
        const buttonLoading = button.querySelector('.button__loading');
        const buttonSuccess = button.querySelector('.button__success');
        
        if (button.disabled) return;
        
        // Loading state
        button.disabled = true;
        if (buttonText) buttonText.style.display = 'none';
        if (buttonLoading) buttonLoading.style.display = 'inline-flex';
        
        try {
          const formData = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (response.ok) {
            const item = await response.json();
            
            // Success state
            if (buttonLoading) buttonLoading.style.display = 'none';
            if (buttonSuccess) buttonSuccess.style.display = 'inline-flex';
            
            // Update cart count
            this.updateCartCount();
            
            // Trigger cart drawer if available
            const cartDrawerEvent = new CustomEvent('cart:add', { 
              detail: { item } 
            });
            document.dispatchEvent(cartDrawerEvent);
            
            // Track event
            if (typeof gtag !== 'undefined') {
              gtag('event', 'add_to_cart', {
                currency: 'USD',
                value: item.price / 100,
                items: [{
                  item_id: item.product_id,
                  item_name: item.product_title,
                  item_variant: item.variant_title,
                  price: item.price / 100,
                  quantity: item.quantity
                }],
                source: 'sticky_cart'
              });
            }
            
            // Reset after delay
            setTimeout(() => {
              if (buttonSuccess) buttonSuccess.style.display = 'none';
              if (buttonText) buttonText.style.display = 'inline-flex';
              button.disabled = false;
            }, 2000);
            
            // Animate cart icon
            this.animateCartIcon();
            
          } else {
            const errorData = await response.json();
            throw new Error(errorData.description || 'Failed to add to cart');
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          
          // Error state
          if (buttonLoading) buttonLoading.style.display = 'none';
          if (buttonText) {
            buttonText.style.display = 'inline-flex';
            const originalText = buttonText.textContent;
            buttonText.textContent = 'Error - Try Again';
            
            setTimeout(() => {
              buttonText.textContent = originalText;
            }, 2000);
          }
          button.disabled = false;
        }
      });
    });
  }
  
  initFloatingCart() {
    if (!this.floatingCart) return;
    
    const trigger = this.floatingCart.querySelector('[data-floating-trigger]');
    const expanded = this.floatingCart.querySelector('[data-floating-expanded]');
    const closeBtn = this.floatingCart.querySelector('[data-floating-close]');
    
    if (!trigger || !expanded) return;
    
    // Toggle expanded state
    trigger.addEventListener('click', () => {
      const isExpanded = this.floatingCart.classList.contains('is-expanded');
      
      if (!isExpanded) {
        this.floatingCart.classList.add('is-expanded');
        
        // Track expansion
        if (typeof gtag !== 'undefined') {
          gtag('event', 'expand_floating_cart', {
            product_id: this.productId
          });
        }
      }
    });
    
    // Close expanded
    closeBtn?.addEventListener('click', (e) => {
      e.stopPropagation();
      this.floatingCart.classList.remove('is-expanded');
    });
    
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (this.floatingCart && !this.floatingCart.contains(e.target)) {
        this.floatingCart.classList.remove('is-expanded');
      }
    });
    
    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.floatingCart.classList.contains('is-expanded')) {
        this.floatingCart.classList.remove('is-expanded');
      }
    });
  }
  
  initDismiss() {
    const closeBtn = this.element.querySelector('[data-sticky-close]');
    
    closeBtn?.addEventListener('click', () => {
      this.hide();
      this.isDismissed = true;
      
      // Save preference for 24 hours
      const expires = new Date();
      expires.setHours(expires.getHours() + 24);
      localStorage.setItem('sticky-cart-dismissed', expires.getTime());
      
      // Track dismissal
      if (typeof gtag !== 'undefined') {
        gtag('event', 'dismiss_sticky_cart', {
          product_id: this.productId,
          time_visible: this.getTimeVisible()
        });
      }
    });
  }
  
  checkDismissed() {
    const dismissedTime = localStorage.getItem('sticky-cart-dismissed');
    if (!dismissedTime) return false;
    
    return parseInt(dismissedTime) > Date.now();
  }
  
  getTimeVisible() {
    if (!this.showTime) return 0;
    return Math.round((Date.now() - this.showTime) / 1000);
  }
  
  initVariantSync() {
    // Listen for variant changes from main product form
    document.addEventListener('variant:change', (e) => {
      const variant = e.detail.variant;
      if (!variant) return;
      
      // Update hidden inputs
      this.element.querySelectorAll('input[name="id"]').forEach(input => {
        input.value = variant.id;
      });
      
      // Update prices
      this.updatePrices(variant);
      
      // Update stock status
      this.updateStockStatus(variant);
      
      // Update variant selector if exists
      const variantSelect = this.element.querySelector('[data-variant-select]');
      if (variantSelect) {
        variantSelect.value = variant.id;
      }
      
      // Update max quantity
      const qtyInputs = this.element.querySelectorAll('[data-qty-input]');
      qtyInputs.forEach(input => {
        if (variant.inventory_management && variant.inventory_quantity > 0) {
          input.max = variant.inventory_quantity;
          
          // Adjust current value if needed
          if (parseInt(input.value) > variant.inventory_quantity) {
            input.value = variant.inventory_quantity;
            this.element.querySelectorAll('[data-qty-value]').forEach(hidden => {
              hidden.value = variant.inventory_quantity;
            });
          }
        }
      });
    });
  }
  
  initVariantSelector() {
    const variantSelect = this.element.querySelector('[data-variant-select]');
    if (!variantSelect) return;
    
    variantSelect.addEventListener('change', (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      
      // Create variant object from data attributes
      const variant = {
        id: e.target.value,
        price: parseFloat(selectedOption.dataset.price) * 100,
        compare_at_price: parseFloat(selectedOption.dataset.comparePrice) * 100,
        available: selectedOption.dataset.available === 'true',
        inventory_quantity: parseInt(selectedOption.dataset.inventory) || 0
      };
      
      // Update variant inputs
      this.element.querySelectorAll('input[name="id"]').forEach(input => {
        input.value = variant.id;
      });
      
      // Update UI
      this.updatePrices(variant);
      this.updateStockStatus(variant);
      
      // Emit event for main form sync
      const event = new CustomEvent('sticky-cart:variant-change', {
        detail: { variant }
      });
      document.dispatchEvent(event);
    });
  }
  
  updatePrices(variant) {
    const currentPrices = this.element.querySelectorAll('.price-current');
    const comparePrices = this.element.querySelectorAll('.price-compare');
    const savingsElements = this.element.querySelectorAll('.price-savings');
    const priceBadges = this.element.querySelectorAll('.price-badge');
    
    currentPrices.forEach(el => {
      el.textContent = money(variant.price);
    });
    
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      comparePrices.forEach(el => {
        el.textContent = money(variant.compare_at_price);
        el.style.display = '';
      });
      
      const savings = (variant.compare_at_price - variant.price) / 100;
      savingsElements.forEach(el => {
        el.textContent = `Save $${savings.toFixed(2)}`;
        el.style.display = '';
      });
      
      const discountPercentage = Math.round((savings / (variant.compare_at_price / 100)) * 100);
      priceBadges.forEach(el => {
        el.textContent = `${discountPercentage}% OFF`;
        el.style.display = '';
      });
    } else {
      comparePrices.forEach(el => el.style.display = 'none');
      savingsElements.forEach(el => el.style.display = 'none');
      priceBadges.forEach(el => el.style.display = 'none');
    }
  }
  
  updateStockStatus(variant) {
    const stockStatus = this.element.querySelector('[data-stock-status]');
    if (!stockStatus) return;
    
    let statusHTML = '';
    
    if (!variant.available) {
      statusHTML = `
        <span class="stock-out">
          <svg class="icon icon--x" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
            <path d="M5 5L9 9M5 9L9 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          Out of Stock
        </span>
      `;
    } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
      statusHTML = `
        <span class="stock-low">
          <svg class="icon icon--alert" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 1L13 12H1L7 1Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M7 5V8M7 10V10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          Only ${variant.inventory_quantity} left!
        </span>
      `;
    } else {
      statusHTML = `
        <span class="stock-available">
          <svg class="icon icon--check" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.5"/>
            <path d="M4 7L6 9L10 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          In Stock
        </span>
      `;
    }
    
    stockStatus.innerHTML = statusHTML;
    
    // Update button states
    const submitButtons = this.element.querySelectorAll('button[type="submit"]');
    submitButtons.forEach(btn => {
      btn.disabled = !variant.available;
      const btnText = btn.querySelector('.button__text');
      if (btnText) {
        btnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    });
  }
  
  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const badges = this.element.querySelectorAll('[data-cart-count]');
      badges.forEach(badge => {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (error) {
      console.error('Failed to update cart count:', error);
    }
  }
  
  animateCartIcon() {
    const cartIcon = this.floatingCart?.querySelector('.trigger-icon');
    if (!cartIcon) return;
    
    cartIcon.animate([
      { transform: 'scale(1) rotate(0deg)' },
      { transform: 'scale(1.2) rotate(10deg)' },
      { transform: 'scale(0.9) rotate(-10deg)' },
      { transform: 'scale(1.1) rotate(5deg)' },
      { transform: 'scale(1) rotate(0deg)' }
    ], {
      duration: 600,
      easing: 'ease-out'
    });
    
    // Also pulse the badge
    const badge = cartIcon.querySelector('[data-cart-count]');
    if (badge && badge.style.display !== 'none') {
      badge.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.3)' },
        { transform: 'scale(1)' }
      ], {
        duration: 300,
        easing: 'ease-out'
      });
    }
  }
}

// Initialize sticky cart
document.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.querySelector('[data-sticky-cart]');
  if (stickyCart) {
    new StickyCart(stickyCart);
  }
});

// Re-initialize on Shopify section load
document.addEventListener('shopify:section:load', (event) => {
  const stickyCart = event.target.querySelector('[data-sticky-cart]');
  if (stickyCart) {
    new StickyCart(stickyCart);
  }
});
;
/* add-to-cart-simple.js */
// Simple Add to Cart - No conflicts
(function() {
  'use strict';
  
  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    // Find all product forms
    const forms = document.querySelectorAll('form[action="/cart/add"]');
    
    forms.forEach((form, index) => {
      // Remove any existing listeners by cloning
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
      
      // Add our handler
      newForm.addEventListener('submit', handleSubmit);
    });
  }
  
  async function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    
    console.log('[AddToCart] Form submitted');
    
    const form = e.target;
    const button = form.querySelector('button[type="submit"]');
    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    
    if (!variantInput || !variantInput.value) {
      console.error('[AddToCart] No variant ID found');
      alert('Please select a product option');
      return;
    }
    
    const variantId = variantInput.value;
    const quantity = quantityInput ? quantityInput.value : 1;
    
    console.log('[AddToCart] Adding to cart:', { variantId, quantity });
    
    // Disable button
    if (button) {
      button.disabled = true;
      button.innerHTML = '<span>Adding...</span>';
    }
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantId),
          quantity: parseInt(quantity)
        })
      });

      // Check response status first before parsing JSON
      if (!response.ok) {
        // Try to get error message from JSON, but handle empty responses
        let errorMessage = 'Failed to add to cart';
        try {
          const errorData = await response.json();
          errorMessage = errorData.description || errorMessage;
        } catch (e) {
          // Response body is empty or not JSON
          errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      const responseData = await response.json();
      console.log('[AddToCart] Response:', responseData);
      
      // Success!
      if (button) {
        button.innerHTML = '<span>Added! ✓</span>';
        setTimeout(() => {
          button.disabled = false;
          const priceLabel = window.formatMoney ? window.formatMoney(responseData.final_price) : '$' + (responseData.final_price / 100).toFixed(2);
          button.innerHTML = '<span class="button__text">Add to Cart - ' + priceLabel + '</span>';
        }, 2000);
      }
      
      // Update cart count
      updateCartCount();
      
      // Open cart drawer if available
      if (window.cartDrawer && window.cartDrawer.open) {
        console.log('[AddToCart] Opening cart drawer via window.cartDrawer');
        // Refresh cart contents first, then open
        if (window.cartDrawer.refreshCart) {
          await window.cartDrawer.refreshCart();
        }
        setTimeout(() => window.cartDrawer.open(), 300);
      } else {
        console.log('[AddToCart] No cart drawer found, trying event dispatch');
        // Try to trigger cart open event
        document.dispatchEvent(new CustomEvent('cart:open'));
        
        // Check cart count to verify item was added
        setTimeout(() => {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              console.log('[AddToCart] Cart contents:', cart);
              if (cart.item_count > 0) {
                alert(`Success! ${cart.item_count} item(s) in cart. Click OK to view cart.`);
                window.location.href = '/cart';
              }
            });
        }, 500);
      }
      
    } catch (error) {
      console.error('[AddToCart] Error:', error);
      
      if (button) {
        button.disabled = false;
        button.innerHTML = '<span>Error - Try Again</span>';
        setTimeout(() => {
          button.innerHTML = '<span class="button__text">Add to Cart</span>';
        }, 2000);
      }
      
      alert(error.message || 'Failed to add to cart');
    }
  }
  
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count === 0) {
          el.classList.add('cart-count--empty');
        } else {
          el.classList.remove('cart-count--empty');
        }
      });
    } catch (error) {
      console.error('[AddToCart] Failed to update cart count:', error);
    }
  }
})();
;
/* quantity-selector-fix.js */
// Quantity Selector Functionality Fix
document.addEventListener('DOMContentLoaded', function() {
  // Handle all quantity selectors on the page
  const initQuantitySelectors = () => {
    const quantitySelectors = document.querySelectorAll('.quantity-selector');
    
    quantitySelectors.forEach(selector => {
      const minusBtn = selector.querySelector('[data-quantity-minus]');
      const plusBtn = selector.querySelector('[data-quantity-plus]');
      const input = selector.querySelector('[data-quantity-input]');
      
      if (!minusBtn || !plusBtn || !input) return;
      
      // Remove any existing listeners to prevent duplicates
      const newMinusBtn = minusBtn.cloneNode(true);
      const newPlusBtn = plusBtn.cloneNode(true);
      minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
      plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
      
      // Add click listeners
      newMinusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 1;
        const minValue = parseInt(input.min) || 1;
        const newValue = Math.max(minValue, currentValue - 1);
        
        input.value = newValue;
        input.classList.add('quantity-changed');
        
        // Trigger change event for other scripts
        input.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Remove animation class after animation completes
        setTimeout(() => {
          input.classList.remove('quantity-changed');
        }, 300);
        
        // Update button states
        updateButtonStates(selector);
      });
      
      newPlusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 1;
        const maxValue = parseInt(input.max) || 999;
        const newValue = Math.min(maxValue, currentValue + 1);
        
        input.value = newValue;
        input.classList.add('quantity-changed');
        
        // Trigger change event for other scripts
        input.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Remove animation class after animation completes
        setTimeout(() => {
          input.classList.remove('quantity-changed');
        }, 300);
        
        // Update button states
        updateButtonStates(selector);
      });
      
      // Handle direct input changes
      input.addEventListener('change', function() {
        let value = parseInt(this.value) || 1;
        const minValue = parseInt(this.min) || 1;
        const maxValue = parseInt(this.max) || 999;
        
        // Clamp value between min and max
        value = Math.max(minValue, Math.min(maxValue, value));
        this.value = value;
        
        updateButtonStates(selector);
      });
      
      // Prevent non-numeric input
      input.addEventListener('keypress', function(e) {
        if (!/\d/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
          e.preventDefault();
        }
      });
      
      // Initial button state
      updateButtonStates(selector);
    });
  };
  
  // Update button disabled states based on current value
  const updateButtonStates = (selector) => {
    const minusBtn = selector.querySelector('[data-quantity-minus]');
    const plusBtn = selector.querySelector('[data-quantity-plus]');
    const input = selector.querySelector('[data-quantity-input]');
    
    if (!minusBtn || !plusBtn || !input) return;
    
    const currentValue = parseInt(input.value) || 1;
    const minValue = parseInt(input.min) || 1;
    const maxValue = parseInt(input.max) || 999;
    
    // Disable minus button at minimum
    minusBtn.disabled = currentValue <= minValue;
    
    // Disable plus button at maximum
    plusBtn.disabled = currentValue >= maxValue;
  };
  
  // Initialize on page load
  initQuantitySelectors();
  
  // Re-initialize when new content is loaded (for AJAX)
  document.addEventListener('shopify:section:load', initQuantitySelectors);
  document.addEventListener('product:variant:change', initQuantitySelectors);
});
;
/* product-benefits-animation.js */
// Professional Benefits Animation
document.addEventListener('DOMContentLoaded', function() {
  // Intersection Observer for scroll animations
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        
        // Animate counters if present
        const counters = entry.target.querySelectorAll('[data-counter]');
        counters.forEach(counter => animateCounter(counter));
        
        // Unobserve after animation
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  // Observe all benefit cards
  document.querySelectorAll('.benefit-card').forEach(card => {
    observer.observe(card);
  });
  
  // Counter animation function
  function animateCounter(element) {
    const target = parseFloat(element.dataset.counter);
    const duration = 2000;
    const start = 0;
    const startTime = performance.now();
    
    function updateCounter(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Ease-out cubic
      const easeOutCubic = 1 - Math.pow(1 - progress, 3);
      const current = start + (target - start) * easeOutCubic;
      
      // Format based on whether it's a decimal
      if (target % 1 !== 0) {
        element.textContent = current.toFixed(1);
      } else {
        element.textContent = Math.floor(current).toLocaleString();
      }
      
      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    }
    
    requestAnimationFrame(updateCounter);
  }
  
  // Add hover effects to icons
  document.querySelectorAll('.benefit-card').forEach(card => {
    const icon = card.querySelector('.benefit-card__icon svg');
    if (icon) {
      card.addEventListener('mouseenter', () => {
        icon.style.transform = 'scale(1.1) rotate(5deg)';
      });
      
      card.addEventListener('mouseleave', () => {
        icon.style.transform = 'scale(1) rotate(0deg)';
      });
    }
  });
});
;
/* product-modern-interactions.js */
// Product page interactions for Casper-style layout
document.addEventListener('DOMContentLoaded', function() {
  
  // Handle mobile floating button position relative to hero section
  function handleMobileFloatingButton() {
    const floatingButton = document.querySelector('.product-mobile-purchase .add-to-cart-btn');
    const heroSection = document.querySelector('.product-hero-section');
    
    if (!floatingButton || !heroSection || window.innerWidth > 768) {
      return;
    }
    
    function updateButtonPosition() {
      const heroRect = heroSection.getBoundingClientRect();
      const heroBottom = heroRect.bottom;
      const viewportHeight = window.innerHeight;
      
      // If hero section bottom is above the button's normal position (80px from bottom)
      if (heroBottom < viewportHeight - 80) {
        floatingButton.classList.add('at-bottom');
      } else {
        floatingButton.classList.remove('at-bottom');
      }
    }
    
    // Update on scroll and resize
    window.addEventListener('scroll', updateButtonPosition);
    window.addEventListener('resize', updateButtonPosition);
    
    // Initial check
    updateButtonPosition();
  }
  
  // Initialize mobile floating button behavior
  handleMobileFloatingButton();
  
  // Handle highlights toggle
  const highlightsToggle = document.querySelector('.highlights-toggle');
  const highlightsContent = document.querySelector('.highlights-content');
  
  if (highlightsToggle && highlightsContent) {
    highlightsToggle.addEventListener('click', function() {
      const isOpen = highlightsContent.style.display !== 'none';
      
      if (isOpen) {
        highlightsContent.style.display = 'none';
        this.classList.remove('is-open');
      } else {
        highlightsContent.style.display = 'block';
        this.classList.add('is-open');
      }
    });
  }
  
  // Handle variant option selection
  const variantOptions = document.querySelectorAll('.size-option');
  variantOptions.forEach(option => {
    const input = option.querySelector('input[type="radio"]');
    
    option.addEventListener('click', function() {
      // Remove selected class from all options in the same group
      const parentGroup = this.closest('.variant-buttons');
      if (parentGroup) {
        parentGroup.querySelectorAll('.size-option').forEach(opt => opt.classList.remove('size-option--selected'));
      }
      
      // Add selected class to clicked option
      this.classList.add('size-option--selected');
      
      // Check the radio button
      if (input) {
        input.checked = true;
      }
    });
  });
  
  // Handle quantity controls
  const quantityInput = document.querySelector('.quantity-input');
  const minusButton = document.querySelector('.quantity-button--minus');
  const plusButton = document.querySelector('.quantity-button--plus');
  
  if (quantityInput && minusButton && plusButton) {
    minusButton.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
    
    plusButton.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value) || 1;
      const maxValue = parseInt(quantityInput.max) || 999;
      if (currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
      }
    });
  }
  
  // Handle financing learn more
  const financingButtons = document.querySelectorAll('.financing-learn-more');
  financingButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Create and show Shop Pay installments modal
      showShopPayModal();
    });
  });

  function showShopPayModal() {
    // Get current price
    const currentPrice = document.querySelector('.price-current')?.textContent?.replace(/[^0-9.]/g, '');
    if (!currentPrice) return;
    
    // Format the quarter payment in the shopper's currency (money-format.js)
    const installmentCents = Math.round((parseFloat(currentPrice) / 4) * 100);
    const installmentAmount = window.formatMoney
      ? window.formatMoney(installmentCents)
      : '$' + (installmentCents / 100).toFixed(2);
    
    // Create modal HTML
    const modalHTML = `
      <div id="shop-pay-modal" style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      ">
        <div style="
          background: white;
          border-radius: 12px;
          padding: 32px;
          max-width: 400px;
          width: 90%;
          text-align: center;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        ">
          <div style="
            width: 60px;
            height: 60px;
            background: #5A31F4;
            border-radius: 50%;
            margin: 0 auto 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: bold;
            font-size: 24px;
          ">SP</div>
          
          <h3 style="margin: 0 0 16px; font-size: 20px; font-weight: 600; color: #1a1a1a;">
            Shop Pay Installments
          </h3>
          
          <p style="margin: 0 0 24px; color: #666; line-height: 1.5;">
            Split your purchase into 4 interest-free payments
          </p>
          
          <div style="
            background: #f8f9fa;
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 24px;
          ">
            <div style="font-size: 14px; color: #666; margin-bottom: 8px;">4 payments of</div>
            <div style="font-size: 24px; font-weight: 700; color: #1a1a1a;">${installmentAmount}</div>
            <div style="font-size: 14px; color: #666; margin-top: 4px;">No interest or fees</div>
          </div>
          
          <p style="margin: 0 0 24px; font-size: 14px; color: #666; line-height: 1.4;">
            You'll see Shop Pay as a payment option at checkout if you're eligible.
          </p>
          
          <button onclick="document.getElementById('shop-pay-modal').remove()" style="
            background: #5A31F4;
            color: white;
            border: none;
            border-radius: 6px;
            padding: 12px 24px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: background 0.2s;
          " onmouseover="this.style.background='#4c28d4'" onmouseout="this.style.background='#5A31F4'">
            Got it
          </button>
        </div>
      </div>
    `;
    
    // Add modal to page
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Close modal when clicking outside
    document.getElementById('shop-pay-modal').addEventListener('click', function(e) {
      if (e.target === this) {
        this.remove();
      }
    });
  }
  
  
  // Add smooth scrolling for rating link
  const ratingLink = document.querySelector('.rating-link');
  if (ratingLink) {
    ratingLink.addEventListener('click', function(e) {
      e.preventDefault();
      const reviewsSection = document.querySelector('#reviews');
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
  
  // Gallery interaction enhancements
  const galleryThumbs = document.querySelectorAll('.gallery__thumb');
  const gallerySlides = document.querySelectorAll('.gallery__slide');
  const galleryDots = document.querySelectorAll('.gallery__dot');
  
  // Handle thumbnail clicks
  galleryThumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', function() {
      // Remove active states
      galleryThumbs.forEach(t => t.classList.remove('is-active'));
      gallerySlides.forEach(s => s.classList.remove('is-active'));
      galleryDots.forEach(d => d.classList.remove('is-active'));
      
      // Add active states
      this.classList.add('is-active');
      if (gallerySlides[index]) {
        gallerySlides[index].classList.add('is-active');
      }
      if (galleryDots[index]) {
        galleryDots[index].classList.add('is-active');
      }
    });
  });
  
  // Handle dot clicks
  galleryDots.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      // Remove active states
      galleryThumbs.forEach(t => t.classList.remove('is-active'));
      gallerySlides.forEach(s => s.classList.remove('is-active'));
      galleryDots.forEach(d => d.classList.remove('is-active'));
      
      // Add active states
      this.classList.add('is-active');
      if (gallerySlides[index]) {
        gallerySlides[index].classList.add('is-active');
      }
      if (galleryThumbs[index]) {
        galleryThumbs[index].classList.add('is-active');
      }
    });
  });
  
  // Handle arrow navigation
  const prevButton = document.querySelector('.gallery__arrow--prev');
  const nextButton = document.querySelector('.gallery__arrow--next');
  
  if (prevButton && nextButton) {
    let currentIndex = 0;
    const totalItems = gallerySlides.length;
    
    function updateGallery(newIndex) {
      // Remove active states
      galleryThumbs.forEach(t => t.classList.remove('is-active'));
      gallerySlides.forEach(s => s.classList.remove('is-active'));
      galleryDots.forEach(d => d.classList.remove('is-active'));
      
      // Add active states
      if (gallerySlides[newIndex]) {
        gallerySlides[newIndex].classList.add('is-active');
      }
      if (galleryThumbs[newIndex]) {
        galleryThumbs[newIndex].classList.add('is-active');
      }
      if (galleryDots[newIndex]) {
        galleryDots[newIndex].classList.add('is-active');
      }
      
      currentIndex = newIndex;
    }
    
    prevButton.addEventListener('click', function() {
      const newIndex = currentIndex > 0 ? currentIndex - 1 : totalItems - 1;
      updateGallery(newIndex);
    });
    
    nextButton.addEventListener('click', function() {
      const newIndex = currentIndex < totalItems - 1 ? currentIndex + 1 : 0;
      updateGallery(newIndex);
    });
  }
});
;
